import { format } from "date-fns";
import { Fragment, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import { ButtonComponent } from "../../../../ui/molecules/button/newButton";
import { Calendar } from "../../../../ui/molecules/calendar";
import { SearchType } from "../../../../ui/molecules/input/Input.types";
import InputSearch from "../../../../ui/molecules/input/InputSearch";
import { MadfarmInput } from "../../../../ui/molecules/input/newInput";
import { ProtocolSearch } from "../../../../ui/molecules/ProtocolSearch";
import { MadfarmStaticSelect } from "../../../../ui/molecules/select/newSelect/static";
import TextArea from "../../../../ui/molecules/textArea";
import { OptionType } from "../../../../utils";
import { GetAllOdc, resetGetAllOdcStatus } from "../../../odc/slice";
import { GetByIdPersonalManagement } from "../../slice";
import { CDXM026Creation, CDXM026Validation, resetCDXM026CreationRequest, resetCDXM026CreationStatus, resetCDXM026Errors, resetCDXM026ValidationStatus, setCDXClientRelationshipType, setCDXEndingDate, setCDXNote, setCDXOperator, setCDXOperatorRelationshipType, setCDXProtocolIdEntry, setCDXStartingDate, setCDXSupervisory } from "../slice";

interface Props {
    close: () => void;
}

export function CDXM026PopupAdd(props: Props) {
    const dispatch = useAppDispatch()
    const CDXM026State = useAppSelector(state => state.PMCDXM026)
    const PMState = useAppSelector(state => state.personalManagement)
    const odcState = useAppSelector(state => state.odc)
    const [odc, setOdc] = useState<OptionType[]>([])

    useEffect(() => {
        dispatch(GetAllOdc({ itemsPerPage: 0, page: 0 }))
    }, [])

    useEffect(() => {
        if (odcState.getAllOdcStatus === 'successfully' && odcState.getAllOdcResponse !== undefined) {
            dispatch(resetGetAllOdcStatus())
            const data = odcState.getAllOdcResponse.data.map(odc => ({
                value: odc.id,
                label: odc.companyName,
            } as OptionType))
            setOdc(data)
        }
    }, [odcState.getAllOdcStatus])

    useEffect(() => {
        if (CDXM026State.CDXM026ValidationStatus === 'successfully') {
            dispatch(resetCDXM026ValidationStatus())
            dispatch(resetCDXM026Errors())
            dispatch(CDXM026Creation(CDXM026State.CDXM026CreationRequest))
        }
    }, [CDXM026State.CDXM026ValidationStatus])

    useEffect(() => {
        if (CDXM026State.CDXM026CreationStatus === 'successfully') {
            dispatch(resetCDXM026CreationRequest())
            dispatch(resetCDXM026CreationStatus())
            dispatch(GetByIdPersonalManagement(PMState.currentPersonalManagementId!))
            props.close()
        }
    }, [CDXM026State.CDXM026CreationStatus])

    return (
        <Fragment>
            <div className="p-6 bg-white flex flex-col gap-6">

                {CDXM026State.CDXM026Errors.errorLabel && (
                    <div className="rounded-lg bg-red-100 px-4 py-3">
                        <span className="text-sm font-semibold text-red-700">
                            {CDXM026State.CDXM026Errors.errorLabel}
                        </span>
                    </div>
                )}

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <InputSearch
                        error={CDXM026State.CDXM026Errors.client}
                        supportingText={CDXM026State.CDXM026Errors.client ? 'Cliente mancante od operatore già presente' : undefined}
                        label="Seleziona Cliente"
                        placeholder="Specifica cliente..."
                        searchType={SearchType.COMPANY_NAME}
                    />
                    <MadfarmInput
                        label="Tipologia Rapporto"
                        placeholder="Specifica tipologia..."
                        value={CDXM026State.CDXM026CreationRequest.clientRelationshipType}
                        defaultValue={CDXM026State.CDXM026CreationRequest.clientRelationshipType}
                        onChangeText={(text) => dispatch(setCDXClientRelationshipType(text))}
                        error={CDXM026State.CDXM026Errors.clientRelationshipType}
                        supportingText={CDXM026State.CDXM026Errors.clientRelationshipType ? 'Rapporto mancante od operatore già presente' : undefined}
                    />
                </div>

                <div className="border-t border-neutral-200 pt-2">
                    <p className="text-md font-semibold uppercase tracking-widest text-brandPrimary-600">
                        Per i clienti non assoggettati a Codex
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <MadfarmInput
                        label="Operatore non assoggettato"
                        placeholder="Specifica operatore..."
                        value={CDXM026State.CDXM026CreationRequest.operator}
                        defaultValue={CDXM026State.CDXM026CreationRequest.operator}
                        onChangeText={(text) => dispatch(setCDXOperator(text))}
                        error={CDXM026State.CDXM026Errors.operator}
                        supportingText={CDXM026State.CDXM026Errors.operator ? 'Operatore mancante o cliente già presente' : undefined}
                    />
                    <MadfarmInput
                        label="Tipologia Rapporto"
                        placeholder="Specifica tipologia..."
                        value={CDXM026State.CDXM026CreationRequest.operatorRelationshipType}
                        defaultValue={CDXM026State.CDXM026CreationRequest.operatorRelationshipType}
                        onChangeText={(text) => dispatch(setCDXOperatorRelationshipType(text))}
                        error={CDXM026State.CDXM026Errors.operatorRelationshipType}
                        supportingText={CDXM026State.CDXM026Errors.operatorRelationshipType ? 'Rapporto mancante o cliente già presente' : undefined}
                    />
                    <MadfarmStaticSelect
                        menuPortalTargetIsNotBody
                        label="Organismo di controllo"
                        placeholder="Seleziona organismo..."
                        options={odc}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            dispatch(setCDXSupervisory(newValue))
                        }}
                        value={CDXM026State.CDXM026CreationRequest.odcId}
                        error={CDXM026State.CDXM026Errors.odc}
                        errorLabel={CDXM026State.CDXM026Errors.odc ? 'ODC mancante o cliente già presente' : undefined}
                        noOptionsMessage={""}
                    />
                </div>

                <div className="border-t border-neutral-200 pt-2">
                    <p className="text-md font-semibold uppercase tracking-widest text-brandPrimary-600">
                        Altri dati
                    </p>
                </div>

                <div className="grid grid-cols-1 gap-6">
                    <ProtocolSearch
                        type="entry"
                        onSelect={(value) => dispatch(setCDXProtocolIdEntry(value))}
                    />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <Calendar
                        label="Data inizio"
                        selected={CDXM026State.CDXM026CreationRequest.starting}
                        onChange={(date) => dispatch(setCDXStartingDate(format(new Date(date), 'yyyy-MM-dd')))}
                    />
                    <Calendar
                        label="Data fine"
                        selected={CDXM026State.CDXM026CreationRequest.ending}
                        onChange={(date) => dispatch(setCDXEndingDate(format(new Date(date), 'yyyy-MM-dd')))}
                    />
                </div>

                <div className="grid grid-cols-1 gap-4">
                    <TextArea
                        label="Note"
                        onChangeText={(text) => dispatch(setCDXNote(text))}
                    />
                </div>

                <div className="flex justify-end gap-2 pt-4 border-t border-neutral-200">
                    <ButtonComponent
                        size="md"
                        variant="outline"
                        iconPosition="off"
                        label="Annulla"
                        color="gray"
                        onClick={() => {
                            dispatch(resetCDXM026Errors())
                            dispatch(resetCDXM026CreationRequest())
                            props.close()
                        }}
                    />
                    <ButtonComponent
                        size="md"
                        variant="solid"
                        iconPosition="off"
                        label="Aggiungi"
                        color="orange"
                        onClick={() => {
                            dispatch(CDXM026Validation(CDXM026State.CDXM026CreationRequest))
                        }}
                    />
                </div>
            </div>
        </Fragment>
    )
}